import { createApp } from 'vue'
import About from './About.vue'
import router from '../../router/mobileMenu.router'


createApp(About).use(router).mount('#about')
